import { createSelector } from 'reselect'
import { selectCancelsAt } from './selectCancelsAt'

export const selectIsPendingCancellation = createSelector(
  selectCancelsAt,
  cancelsAt => !!cancelsAt
)
